<template>
    <div class="lg:w-[90%] 2xl:w-[1000px] mx-auto ">
        <div class="flex flex-wrap justify-between">
            <div class="w-[49%]">
                <label for="phoneNumber" class="text-gray-400 pb-1 text-[13px] 2xl:text-[16px]">Phone Number</label>
                <inputComponent
ref="phoneRef" v-model="phone" name="phone" mask="(###) ###-####"
                    placeholder="Enter Number" error-message="Invalid phone number"
                    custom-class="!w-full h-[35px] !p-2.5 !rounded-md !border !outline-none !text-[12px] largeDesktop:!text-sm !text-[#333]"
/>
            </div>
            <div class="w-[49%]">
                <label for="email" class="text-gray-400 text-[13px] 2xl:text-[16px] pb-1">Email</label>
                <inputComponent
ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX"
                    error-message="Please enter a valid email address" placeholder="Enter Email"
                    custom-class="!w-full h-[35px] !p-2.5 !rounded-md !border !outline-none !text-[12px] largeDesktop:!text-sm !text-[#333]"
/>
            </div>
        </div>
        <div class="py-2">
            <p class="mb-0 text-[13px] largeDesktop:text-[14px] text-[#999999]">
By proceeding, I confirm that I have obtained the
                customer’s
                explicit
                consent to share their
                contact
                information with fyxify for the purpose of receiving communications about service plans and related
                offerings. The customer understands that fyxify may contact them via phone, SMS, or email for
                sales-related purposes.
</p>
        </div>
        <div class="py-1 2xl:py-2">
            <label class="flex mobie:items-start laptop:items-center space-x-3 cursor-pointer">
                <input v-model="consentGiven" type="checkbox" class="peer hidden">
                <div
                    class="mobile:!min-w-[20px] mobile:!h-[20px] largeDesktop:min-w-[25px] largeDesktop:h-[25px] !m-0 border-[1px] rounded-[5px] flex items-center justify-center transition border-[#A084E8] peer-checked:bg-[#fff] peer-checked:border-[#A18BFF]"
>
                    <svg
v-if="consentGiven" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 largeDesktop:w-5 largeDesktop:h-5 text-[#A084E8]"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                <span class="text-[13px] largeDesktop:text-[14px] leading-tight font-roboto text-[#999999]">
                    I confirm that I have received the customer’s consent to be contacted by fyxify for service
                    plan-related communications.
                </span>
            </label>
        </div>
        <div class="flex justify-center items-center pt-2 2xl:pt-4 gap-3">
            <button
:disabled="!(consentGiven && selectedPlans?.length > 0)" type="button" class="px-2 py-1 2xl:px-4 2xl:py-2 text-[14px] 2xl:text-[16px] rounded-md 2xl:rounded-lg !border !border-[#A084E8] text-[#A084E8] hover:text-white hover:bg-[#A084E8] [@media(max-width:1023px)]:!text-white [@media(max-width:1023px)]:!bg-[#A084E8] disabled:cursor-not-allowed disabled:!border disabled:!border-[#CCCCCC] disabled:!text-[#CCCCCC] disabled:!bg-[#fff]"
                @click="generateURL()"
>
                Generate URL
</button>
            <button
:disabled="!isValid()" type="button" class="px-4 py-1 2xl:px-8 2xl:py-2 text-[14px] 2xl:text-[16px] rounded-md 2xl:rounded-lg !border !border-secondary-100 text-secondary-100 hover:text-white hover:bg-secondary-100 disabled:cursor-not-allowed disabled:!border disabled:!border-[#CCCCCC] disabled:!text-[#CCCCCC] disabled:bg-[#fff]"
                @click="sendSharedURL()"
>
                Send
</button>
        </div>
        <div v-if="shareLink && selectedPlans?.length > 0" class="mt-2 2xl:mt-4 w-[300px] 2xl:w-[400px] mx-auto">
            <div
                class="relative w-full h-[30px] 2xl:h-[42px] rounded-md 2xl:rounded-lg !border !border-purple-100 bg-[#EFEFEF80]"
>
                <input
ref="shareinput" v-model="shareinputValue" type="text"
                    class="w-full h-full p-1.5 2xl:p-2.5 !border-0 outline-none !text-[12px] largeDesktop:text-base !text-[#666666] " disabled
>
                <button
class="absolute top-0 -right-[1px] h-full w-[34px] 2xl:w-[42px] rounded-r-md 2xl:rounded-r-lg flex items-center justify-center bg-purple-100"
                    @click="copysharelink"
>
                    <img src="../../assets/images/copy-icon.png" alt="Share Icon" class="w-4 h-4 2xl:w-6 2xl:h-6">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import inputComponent from "../../components/partialComponent/inputComponent.vue";
export default {

    components: {
        inputComponent
    },
    props: ["selectedPlans", "reset"],
    data() {
        return {
            consentGiven: false,
            shareinputValue: '',
            phone: '',
            email: '',
            shareLink: false
        }
    },
    computed: {
        ...mapGetters([
            "shareProtectionPlanURL"
        ]),
    },
    watch: {
        shareProtectionPlanURL: function (data) {
            if (data) {
                this.shareLink = true
                this.shareinputValue = this.shareProtectionPlanURL.url
            }
        },

        reset: function (data) {
            this.consentGiven = false
            this.shareinputValue = ''
            this.phone = ''
            this.email = ''
            this.shareLink = false
        },

        selectedPlans: {
            handler(data) {
                this.shareLink = false
                this.shareinputValue = ''
            },
            deep: true
        }
    },
    methods: {
        ...mapActions([
            "getShareProtectionPlanURL",
        ]),
        isValid() {
            let status = true;
            const hasEmail = this.email && this.email.trim().length > 0;
            const hasPhone = this.phone && this.phone.trim().length > 0;

            if (!hasEmail && !hasPhone) {
                status = false;
            }

            if (hasEmail && !this.validateEmail()) {
                status = false;
            }

            if (hasPhone && this.phone.trim().length !== 14) {
                status = false;
            }

            if (this.consentGiven != true) {
                status = false;
            }

            if (!this.selectedPlans?.length > 0) {
                status = false;
            }

            return status;
        },
        copysharelink() {
            navigator.clipboard.writeText(this.shareinputValue)
            toast.success("Shared URL copied successfully!");

        },
        acceptNumber() {
            var x = this.phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.phone = !x[2] ?
                x[1] :
                "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");

        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        validateEmail() {
            var regex = this.$constants.EMAIL_REGEX;
            return regex.test(this.email);
        },

        sendSharedURL() {
            let payload = {
                'items': JSON.stringify(this.selectedPlans),
                'email': this.email,
                'phone': this.phone
            }
            if (!this.$helper.isEmpty(this.shareinputValue)) {
                payload['url_id'] = this.shareProtectionPlanURL.url_id
            }
            this.$emit("sendBtnClick", payload);
        },
        generateURL() {
            this.getShareProtectionPlanURL({
                'items': JSON.stringify(this.selectedPlans)
            })

        }
    }
}
</script>